var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.matchup)?_c('div',[(_vm.quizProgress)?_c('b-progress',{staticClass:"rounded-0",attrs:{"value":_vm.quizProgress,"max":_vm.barMax,"height":"1rem","variant":"info"}}):_vm._e()],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }